export default "__VITE_ASSET__CJ5yPAVJ__"